<template>
  <div class="award-card">
    <div class="award-card__head">
      <img :src="product.teaser_image" :alt="translate('lblProductImageAlt')" />
      <img class="award-card__badge" v-if="product.badges" :src="product.badges[0].image" :alt="product.badges[0].image_caption" />
    </div>
    <div class="award-card__content">
      <h3 class="h3 bold" v-html="product.teaser_title"></h3>
      <p class="mb-3" v-if="product.teaser_text" v-html="product.teaser_text"></p>
      <a
        v-if="product.learn_more_link"
        :href="product.learn_more_link"
        class="link-more link-more--long"
        v-text="translate('lblFindOutMore')"
      ></a>
    </div>
    <div class="award-detail--checkout">
      <div
        class="award-detail--checkout--variety"
        v-if="product.variants && product.variants.length > 0"
      >
        <label
          :for="product.entity_id"
          v-text="translate('lblVariety')"
        ></label>
        <select :id="product.entity_id" name="variety" v-model="currentVariant">
          <option
            v-if="product.variants.length > 1"
            value=""
            selected="selected"
            v-text="translate('lblVarietyDropdown')"
          ></option>
          <option
            v-for="variant in product.variants"
            :key="variant.articlenumber"
            :value="variant.articlenumber"
            v-text="variant.title"
          ></option>
        </select>
      </div>
      <div class="award-detail--checkout--quantity">
        <label for="product-quantity" v-text="translate('lblQuantity')"></label>
        <input
          id="product-quantity"
          type="number"
          name="quantity"
          inputMode="numeric"
          pattern="[0-9]*"
          min="1"
          max="999"
          v-model="productAmount"
        />
      </div>
      <div class="award-detail--checkout--price">
        <span v-text="translate('lblPrice')"></span>
        <span v-text="product.points"></span>
      </div>
      <a
        :href="productDetailUrl"
        class="button button--primary button--medium"
        v-text="translate('btnCheckout')"
      ></a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AwardCard',
  data: () => ({
    productAmount: 1,
    currentVariant: '',
  }),
  props: {
    product: Object,
  },
  computed: {
    productDetailUrl() {
      let url = this.product.href;

      if (this.productAmount > 1) {
        url += `&amount=${this.productAmount}`;
      }

      if (this.currentVariant !== '') {
        url += `&variant=${this.currentVariant}`;
      }

      return url;
    },
  },
  created() {
    if (this.product.variants?.length === 1) {
      this.currentVariant = this.product.variants[0].articlenumber;
    }
  },
};
</script>

<style lang="scss">
.award-card {
  display: flex;
  flex-direction: column;

  &__head {
    position: relative;
  }

  &__badge {
    position: absolute;
    right: 0;
    bottom: 0;
    width: rem(50);
    height: rem(50);
    margin: rem(12);
  }

  &__content {
    flex-grow: 1;
    padding: 0 rem(15);

    h3 {
      margin: rem(20) 0;
    }

    a {
      &.link-more {
        font-size: 1rem;
      }
    }
  }

  .award-detail {
    &--checkout {
      flex: 0 1 0;
      margin-top: rem(20);
      padding: 0 rem(15);
      padding-bottom: rem(15);

      a {
        width: 100%;
      }

      &--quantity input {
        flex-basis: rem(160) !important;

        @media (min-width: rem(768)) {
          flex-basis: rem(136) !important;
        }

        @media (min-width: rem(1280)) {
          flex-basis: rem(168) !important;
        }
      }

      &--price {
        margin-bottom: rem(15);

        span {
          font-size: rem(24) !important;

          &:first-of-type {
            font-size: 1rem !important;
          }
        }
      }
    }
  }
}
</style>
